module.exports = __webpack_public_path__ + "static/img/sjjc.75ea9fdf.png";